
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import { MessageBox } from "element-ui";
import Pagination from "@/comp/Pagination/index.vue";
import { aclList, aclSave, aclRemove, aclLogList } from "@/api/request/system";

//组件
@Component({
  name: "Words",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;

  //请求参数
  private listQuery: any = {
    //页码数据
    page: 1,
    page_size: 20,

    //上传数据
    value: "", //值
    top_type: 0, //主类型
    sub_type: 0, //子类型
  };

  //主类型
  private topTypeList: any[] = [
    { type: 0, name: "全部主类型" },
    { type: 1, name: "IP" },
    { type: 2, name: "设备" },
  ];

  //子类型
  private subTypeList: any[] = [
    { type: 0, name: "全部子类型" },
    { type: 1, name: "白名单" },
    { type: 2, name: "黑名单" },
  ];

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await aclList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private async handleLog() {
    //初始化数据
    this.logList = [];

    //显示界面
    this.logDialogVisible = true;

    //显示等待
    this.logDialogLoading = true;

    //获取数据
    const { data } = await aclLogList({});

    //数据赋值
    this.logList = data;

    //隐藏等待
    setTimeout(() => {
      this.logDialogLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //处理创建
  private handleCreate(): void {
    //数据赋值
    this.addForm = {
      id: 0, // ID
      value: "", //值
      top_type: 0, //主类型
      sub_type: 0, //子类型
    };
    this.dialogStatus = "create";

    //显示界面
    this.dialogVisible = true;
  }

  //处理删除
  private handleDelete(row: any): void {
    //显示提示
    MessageBox.confirm("删除操作不可恢复，确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //处理删除操作
        await aclRemove({ id: row.id });

        //显示提示
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //处理编辑
  private handleUpdate(row: any): void {
    //数据赋值
    this.addForm = {
      id: row.id, // ID
      value: row.value, //值
      top_type: row.top_type, //主类型
      sub_type: row.sub_type, //子类型
    };
    this.dialogStatus = "update";

    //显示界面
    this.dialogVisible = true;
  }

  //--------------------------------- 添加/编辑 ---------------------------------
  //定义变量
  private dialogStatus: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;
  private titleMap = { update: "编辑黑白名单", create: "新增黑白名单" };

  //添加表单
  private addForm: any = {
    id: 0, // ID
    value: "", //值
    top_type: 0, //主类型
    sub_type: 0, //子类型
  };

  //主类型
  private topTypeSelect: any[] = [
    { type: 0, name: "请选择主类型" },
    { type: 1, name: "IP" },
    { type: 2, name: "设备" },
  ];

  //子类型
  private subTypeSelect: any[] = [
    { type: 0, name: "请选择子类型" },
    { type: 1, name: "白名单" },
    { type: 2, name: "黑名单" },
  ];

  //创建敏感词
  private async createData() {
    //数据处理
    if (this.addForm.value == "") return this.$message.error("请输入值");
    if (this.addForm.top_type == 0) return this.$message.error("请选择主类型");
    if (this.addForm.sub_type == 0) return this.$message.error("请选择子类型");

    //显示等待
    this.dialogLoading = true;

    //超时隐藏
    setTimeout(() => {
      this.dialogLoading = false;
    }, 5000);

    //保存数据
    await aclSave(this.addForm);

    //隐藏等待
    this.dialogLoading = false;

    //隐藏界面
    this.dialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });

    //获取列表
    this.getList();
  }

  //更新敏感词
  private async updateData() {
    //数据处理
    if (this.addForm.value == "") return this.$message.error("请输入值");
    if (this.addForm.top_type == 0) return this.$message.error("请选择主类型");
    if (this.addForm.sub_type == 0) return this.$message.error("请选择子类型");

    //显示等待
    this.dialogLoading = true;

    //保存数据
    await aclSave(this.addForm);

    //隐藏等待
    this.dialogLoading = false;

    //隐藏界面
    this.dialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "编辑成功",
      type: "success",
      duration: 2000,
    });

    //获取列表
    this.getList();
  }

  //是否创建
  private isCreate(): boolean {
    return this.dialogStatus === "create";
  }

  //--------------------------------- 触发记录 ---------------------------------
  //定义变量
  private logList: any[] = [];
  private logDialogVisible: boolean = false;
  private logDialogLoading: boolean = false;
}
